import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { apiUrl } from "../apiUrl";

export const getNotasByCitaId = createAsyncThunk(
    "notasCita/getByCitaId",
    async (citaId) => {
        const { data } = await axios.get(`${apiUrl}/api/v1/notas-citas/cita/${citaId}`);
        return data;
    }
);

export const saveNotasCita = createAsyncThunk(
    "notasCita/save",
    async (body) => {
        const { data } = await axios.post(
            `${apiUrl}/api/v1/notas-citas`,
            { cita_id: body.cita_id, notas: body.notas },
            { headers: { 'Content-Type': 'application/json' } }
        );
        return data;
    }
);

const initialState = {
    status: "idle",
    notasCita: [],
    notasCitaId: null,
    error: null,
};

export const notasCitaSlice = createSlice({
    name: "notasCita",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getNotasByCitaId.pending, (state) => {
                state.status = "loading";
            })
            .addCase(getNotasByCitaId.fulfilled, (state, action) => {
                state.status = "succeed";
                state.notasCita = action.payload;
                state.notasCitaId = action.meta.arg;
            })
            .addCase(getNotasByCitaId.rejected, (state, action) => {
                state.status = "failed";
                state.error = action.error.message;
            })
            .addCase(saveNotasCita.pending, (state) => {
                state.status = "loading";
            })
            .addCase(saveNotasCita.fulfilled, (state, action) => {
                state.status = "succeed";
                state.notasCita = action.payload;
            })
            .addCase(saveNotasCita.rejected, (state, action) => {
                state.status = "failed";
                state.error = action.error.message;
            });
    },
});

export const getAllNotasCita = (state) => state.notasCita.notasCita;
export const getNotasCitaStatus = (state) => state.notasCita.status;
export const getNotasCitaId = (state) => state.notasCita.notasCitaId;

export default notasCitaSlice.reducer;
